module.exports = __webpack_public_path__ + "static/collaborative-21ed7e6488155704ce9640fd7ddd5ab8.svg";